import { isApiError } from './api-error';

const RETRIES = 1;

export const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= RETRIES) return false;
  if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
  return true;
};
